import React from "react";
import { styled } from "@mui/material/styles";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: "#fff",
}));

const Loader = ({ open = false, children }) => {
  return (
    <StyledBackdrop open={open}>
      <CircularProgress color="inherit" />
      {children}
    </StyledBackdrop>
  );
};

export default Loader;
